import { render } from "./removeClientPopup.vue?vue&type=template&id=7fc70652&scoped=true"
import script from "./removeClientPopup.vue?vue&type=script&lang=js"
export * from "./removeClientPopup.vue?vue&type=script&lang=js"

import "./removeClientPopup.vue?vue&type=style&index=0&id=7fc70652&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc70652"]])

export default __exports__